module.exports = __webpack_public_path__ + "img/ok_square_off_icon.071c9f4d.svg";